module.exports = __webpack_public_path__ + "static/media/gen_ani_det.ca028a77.png";